import { Component } from "@angular/core";

@Component({
  selector: "app-background-black",
  templateUrl: "./background-black.component.html",
  styleUrls: ["./background-black.component.scss"],
})
export class BackgroundBlackComponent {}
